/**
 * Display rule for cargo numeric fields (quantity, weight, dimensions, etc.)
 * on read-only/public/driver views: never show "-" and never show a negative
 * number — an unfilled value displays as 0.
 */
export function displayCargoNumber(
  value: number | null | undefined,
): number {
  if (value === null || value === undefined || Number.isNaN(value)) return 0;
  return Math.max(0, value);
}
